<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('monitoringCenter.home') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('zi-yuan-zhong-xin') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('dian-biao-zhong-duan-cai-ji') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">

        <el-tab-pane :label="$t('chao-biao-cai-ji-lie-biao')" name="typeList">
        </el-tab-pane>
        <el-form :model="searchForm" ref="form" size="mini" :inline="true">
          <el-col :span="3">
          <el-form-item label="">
            <el-select  :filter-method="filterValue" scollapse-tags filterable v-model="searchForm.operatorId"  size="mini" :placeholder="$t('monitoringCenter.opsTreePlaceholder')" clearable @change="changeOpertorId(val)">
              <el-option v-for="item in listForSelectTree" :key="item.value" :label="item.label"  :value="item.value">{{item.label}}</el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="3">
          <el-form-item label="">
            <el-select filterable v-model="searchForm.stationId" size="mini" clearable :placeholder="$t('qing-xuan-ze-zhan-dian')" >
              <el-option v-for="item in stations" :key="item.id" :label="item.stationName" :value="item.id">{{item.stationName}}</el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="meterTerminalName">

         <el-select
          size="mini"
          remote
          filterable
          clearable
          reserve-keyword

          :remote-method="searchCustomerByPhone"
          :loading="searchLoading"
          v-model="searchForm.meterTerminalCode"
          class="userRole" :placeholder="$t('qing-zhi-shao-shu-ru-wu-wei-cai-ji-zhong-duan-bian-hao-cha-xun')" >
                <el-option v-for="item in meterAcquisitios" :key="item.imeterTerminalCode"
                  :label="item.meterTerminalName" :value="item.meterTerminalCode">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="state">
              <el-select  v-model="searchForm.state" :placeholder="$t('qing-xuan-ze-zhong-duan-zhuang-tai-0')" clearable @change="changeState(val)">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item prop="networkType">
              <el-select v-model="searchForm.networkType" :placeholder="$t('qing-xuan-ze-zhong-duan-wang-luo')" @change="changenetworkType(val)">
                <el-option v-for="item in optionsNetWork" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item>
              <el-button size="mini" type="primary" @click="resetSearchForm">{{ $t('deviceControl.empty') }}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="1.5">
            <el-form-item label="">
              <el-button  v-if="checkPermission(['bee:res:terminal:insertOrUpdate'])" type="primary" size="mini" @click="add('新增')">{{ $t('paramMonitor.add') }}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="1.5">
            <el-form-item>
              <el-button v-if="checkPermission(['bee:res:terminal:page'])" type="primary" icon="el-icon-search" @click="submitSearchForm" :loading="getSearchLoading">{{ $t('deviceControl.search') }}
              </el-button>
            </el-form-item>
          </el-col>

        </el-form>

        <!--列表-->
        <el-table size="mini" @selection-change="selectChange" :data="tableData" highlight-current-row
          v-loading="searchLoading" border :element-loading-text="$t('paramMonitor.Loading')" style="width: 100%;">
          <af-table-column align="center" prop="meterTerminalName" :label="$t('cai-ji-ming-cheng')" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="meterTerminalCode" :label="$t('cai-ji-code')" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="operatorId" :label="$t('yun-ying-shang-code')" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="name" :label="$t('yun-ying-shang-ming')" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="sim" :label="$t('zhong-duan-ka-hao')" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="meterNums" :label="$t('dian-biao-ge-shu')" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="state" :formatter="ifuserType" :label="$t('qi-dong-zhuang-tai')" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="signals" :label="$t('xin-hao-fu-zhi-0') " min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="imei" :label="$t('tong-xin-mo-kuai-imei-hao-ma-0')  " min-width="80px">
          </af-table-column>
          </af-table-column>
          <af-table-column :label="$t('deviceControl.operation')" width="300px">
            <template slot-scope="scope">
              <el-button v-if="checkPermission(['bee:res:terminal:insertOrUpdate'])" size="mini" @click="handleEdit(scope.$index, scope.row,'编辑')">{{ $t('alaramMonitor.edit') }}</el-button>
              <el-button size="mini" @click="selectEdit(scope.$index, scope.row,'详情')">{{ $t('xiang-qing-0') }}</el-button>
              <el-button v-if="checkPermission(['bee:res:terminal:delete'])" size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">{{ $t('deviceControl.delete') }}</el-button>

            </template>
          </af-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage4" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
          :total="this.pageparam.total">
        </el-pagination>
      </el-tabs>
      <!-- 新增编辑界面 -->
      <el-dialog :title="tit" :visible.sync="editFormVisible" width="40%" :before-close="handleDialogClose">
        <div class="el-dialog-div">


          <el-form label-width="100px" ref="form" :model="addOrEditForm" :rules="rules" class="demo-ruleForm">
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('cai-ji-ming-cheng-0')" prop="meterTerminalName">
                  <el-input :disabled="meterCodeVisible" v-model="addOrEditForm.meterTerminalName" :placeholder="$t('qing-shu-ru-cai-ji-ming-cheng')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('cai-ji-code-0')" prop="meterTerminalCode">
                  <el-input :disabled="meterCodeVisible" v-model="addOrEditForm.meterTerminalCode" :placeholder="$t('qing-shu-ru-cai-ji-ming-cheng-0')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('cai-ji-zhuang-tai')" prop="state">
                  <el-select v-model="zeroHourStatus" :placeholder="$t('qing-xuan-ze-zhong-duan-zhuang-tai-0')" @change="change('val')">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('xie-yi-lei-xing')" prop="agreementType">
                  <el-select v-model="addOrEditForm.agreementType" :placeholder="$t('qing-xuan-ze-zhong-duan-xie-yi')" :disabled="true">
                    <el-option v-for="item in agreementTypes" :key="item.value" :label="item.label" :value="0">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('ban-ben-0')" prop="nowVersion">
                  <el-input v-model="addOrEditForm.nowVersion" :placeholder="$t('qing-shu-ru-ban-ben')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('wang-luo')" prop="networkType">
                  <el-select v-model="addOrEditForm.networkType" :placeholder="$t('qing-xuan-ze-zhong-duan-wang-luo-0')" @change="change('val')">
                    <el-option v-for="item in optionsNetWork" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('deviceControl.operatorId')" prop="operatorId">
                  <el-select v-model="addOrEditForm.operatorId" :placeholder="$t('monitoringCenter.opsTreePlaceholder')" @change="changeOpertorId('val')">
                    <el-option v-for="item in listForSelectTree" :key="item.value" :label="item.label"
                      :value="item.value">{{item.label}}</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('chong-dian-zhan')" prop="stationId">
                  <el-select v-model="addOrEditForm.stationId" :placeholder="$t('qing-xuan-ze-zhan-dian')" @change="changeStationId('val')">
                    <el-option v-for="item in stations" :key="item.id" :label="item.stationName" :value="item.id">
                      {{item.stationName}}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('dian-biao-ma')" prop="meterCode">
                  <el-select v-model="addOrEditForm.meterCode" :placeholder="$t('qing-xuan-ze-dian-biao-ma-yi-ge-huo-duo-ge')" multiple>
                    <el-option v-for="item in meterCodes" :key="item.meterCode" :label="item.meterCode"
                      :value="item.meterCode">{{item.meterCode}}</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!--               <el-form-item label="电表地址" prop="meterAddr">
                  <el-select v-model="addOrEditForm.meterAddr" placeholder="请选择站点" @change="change()">
                    <el-option v-for="item in meterAddrs" :key="item.id" :label="item.meterAddr" :value="item.id">
                      {{item.meterAddr}}</el-option>
                  </el-select>
                </el-form-item> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('xin-hao-fu-zhi-1')" prop="signals">
                  <el-input v-model="addOrEditForm.signals" :placeholder="$t('qing-shu-ru-xin-hao-fu-zhi')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('imei-hao-ma')" prop="imei">
                  <el-input v-model="addOrEditForm.imei" :placeholder="$t('qing-shu-ru-tong-xin-mo-kuai-imei-hao-ma')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('sim-ka-hao-ma-0')" prop="sim">
                  <el-input v-model="addOrEditForm.sim" :placeholder="$t('qing-shu-ru-sim-ka-hao-ma-0')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('deng-lu-duan-kou-0')" prop="loginPort">
                  <el-input v-model="addOrEditForm.loginPort" :placeholder="$t('qing-shu-ru-duan-kou')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('deng-lu-ip-0')" prop="loginIp">
                  <el-input v-model="addOrEditForm.loginIp" :placeholder="$t('qing-shu-ru-deng-lu-ip')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="10">
                <el-form-item :label="$t('zhuang-duan-fei-shuai')" prop="timeSharingAccountingId">
                  <el-select v-model="addOrEditForm.timeSharingAccountingId" :placeholder="$t('zhuang-duan-fei-shuai-0')"
                    @change="change('val')">
                    <el-option v-for="item in serviceBillingRulesSelect" :key="item.id" :label="item.ruleName" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('val')">{{ $t('alaramMonitor.cancel') }}</el-button>
          <el-button size="small" type="primary" :loading="loading" @click="submitForm('addOrEditForm')">
            {{ $t('alaramMonitor.preserve') }}
          </el-button>

        </div>
      </el-dialog>
      <!-- 详情界面 -->
      <el-dialog :title="tit" :visible.sync="infoFormVisible" width="40%" :before-close="infoDialogClose">
        <div class="el-dialog-div">


          <el-form label-width="100px" :model="addOrEditForm">
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('cai-ji-ming-cheng-1')">
                  {{addOrEditForm.meterTerminalName}}

                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('cai-ji-code-1')">
                  {{addOrEditForm.meterTerminalCode}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('cai-ji-zhuang-tai-0')">
                  {{state}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('xie-yi-lei-xing-0')">
                  {{addOrEditForm.agreementType}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('ban-ben-1')">
                  {{addOrEditForm.nowVersion}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('wang-luo-0')">
                  {{addOrEditForm.networkTypeMsg}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>

              <el-col :span="10">
                <el-form-item :label="$t('dian-biao-di-zhi')">
                  {{addOrEditForm.meterAddrs}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('dian-biao-code')">
                  {{addOrEditForm.meterCodeNums}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('zhan-chang-bian-hao')">
                  {{addOrEditForm.stationCode}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('yun-ying-shang-hao')">
                  {{addOrEditForm.operatorId}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('imei-hao-ma-0')">
                  {{addOrEditForm.imei}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('xin-hao-fu-zhi-2')">
                  {{addOrEditForm.signals}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('sim-ka-hao')">
                  {{addOrEditForm.sim}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('deng-lu-duan-kou-1')">
                  {{addOrEditForm.loginPort}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('deng-lu-ip-1')">
                  {{addOrEditForm.loginIp}}
                </el-form-item>

              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('dian-biao-ge-shu-0')">
                  {{addOrEditForm.meterNums}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('zhuang-duan-fei-shuai-1')" >
                  <el-select  disabled v-model="addOrEditForm.timeSharingAccountingId" :placeholder="$t('zhuang-duan-fei-shuai-2')"
                    @change="change('val')">
                    <el-option v-for="item in serviceBillingRulesSelect" :key="item.id" :label="item.ruleName" :value="item.id">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>

            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="infoClose('val')">{{ $t('alaramMonitor.cancel') }}</el-button>


        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
  import Pagination from '@/module/operatingCenter/component/Pagination'
  import terminalApi from '@/module/resourceCenter/api/meterAcquisitionTerminalApi'
  import pileDateQueManagerApi from '@/module/resourceCenter/api/pileDateQueManagerApi'
  import configApi from '@/module/resourceCenter/api/meterConfigurationApi'
  import stationApi from '@/module/resourceCenter/api/stationApi';
  export default {

    name: 'personPileManager',
    data() {
      var isPriceVlidator = (rule, value, callback) => {
        var pattern = /^\d+.?\d{0,2}$/;
        if (!Number.isInteger(+value)) {
          callback(new Error(this.$t('zhi-neng-shu-ru-shu-zi-zhi')))
        } else return callback()
      }
      var validcodeip = (rule, value, callback) => {
        const reg =
          /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error(this.$t('shu-ru-ge-shi-bu-he-fa')));
        }
      }
      var isPrice = (rule, value, callback) => {
        var pattern = /[^\d.]/g
        if (!pattern.test(value)) {
          callback(new Error(this.$t('zhi-neng-shu-ru-shu-zi-he-xiao-shu-dian')))
        } else return callback()
      }

      return {
        searchForm: {
          meterTerminalName: '',
          state: '',
          id:'',
          nowVersion: '',
          operatorId:'',
          stationId:'',
          networkType: '',
          loginPort: '',
          loginIp: '',
        },
        form: {},
        state:'',
        meterAcquisitios:[],
        editForm: {},
        editFormVisible: false,
        loading: false,
        meterCodeVisible:false,
        tableData: [],
        zeroHourStatus:'',
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        // rules表单验证
        rules: {
          meterTerminalName: [{
            required: true,
            message: this.$t('qing-shu-ru-cai-ji-zhong-duan-ming'),
            trigger: 'blur'
          }],
          stationId: [{
            required: true,
            message: this.$t('qing-xuan-ze-cai-ji-zhan-dian'),
            trigger: 'blur'
          }],
          meterTerminalCode: [{
            required: true,
            message: this.$t('qing-shu-ru-cai-ji-zhong-duan-code'),
            trigger: 'blur'
          }, {
            validator: isPriceVlidator,
            message: this.$t('cai-ji-zhong-duan-code-zhi-neng-shi-shu-zi'),
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: this.$t('qing-xuan-ze-zhuang-tai'),
            trigger: 'blur'
          }],


          agreementType: [{
            required: true,
            message: this.$t('qing-shu-ru-xin-hao-fu-zhi-0'),
            trigger: 'blur'
          }],


          operatorId: [{
            required: true,
            message: this.$t('qing-shu-ru-deng-lu-duan-kou'),
            trigger: 'blur'
          }],
          timeSharingAccountingId: [{
            required: true,
            message: this.$t('qing-xuan-ze-hui-shuai-id'),
            trigger: 'blur'
          }],

        },
        meterAddrs: [],
        meterCodes: [],
        currentPage4: 0,
        tit: '',
        addOrEditForm: {
          id: '',
          meterTerminalName: '',
          meterTerminalCode: '',
          meterNums: '',
          meterCodeNums: '',
          stationCode: '',
          state: null,
          agreementType: 0,
          networkType: '',
          networkTypeMsg: '',
          nowVersion: '',
          operatorId: '',
          stationId: '',
          meterCode: '',
          signals: '',
          meterAddrs: '',
          imei: '',
          sim: '',
          loginPort: '',
          meterAddr: '',
          loginIp: '',
          timeSharingAccountingId:''
        },
        changeEditForm: {
          id: '',
          meterTerminalName: '',
          meterTerminalCode: '',
          meterNums: '',
          meterCodeNums: '',
          stationCode: '',
          state: '',
          agreementType: 0,
          networkType: '',
          networkTypeMsg: '',
          nowVersion: '',
          operatorId: '',
          stationId: '',
          meterCode: '',
          signals: '',
          meterAddrs: '',
          imei: '',
          sim: '',
          loginPort: '',
          meterAddr: '',
          loginIp: '',
           timeSharingAccountingId:''
        },
        options2:[],
        options: [{
          value: "0",
          label: this.$t('chargingMonitor.offline')
        }, {
          value: "1",
          label: this.$t('zai-xian')
        }, {
          value: "2",
          label: this.$t('chargingMonitor.chargeFault')
        }],
        optionsNetWork: [{
          value: "1",
          label: this.$t('you-xian-wang')
        }, {
          value: "0",
          label: this.$t('wu-xian-wang')
        }],
        stations: [],
        listForSelectTree: [],
        agreementTypes: [{
          value: '0',
          label: this.$t('dian-wang-kuai-chong')
        }],
        activeName: '',
        listLoading: '',
        showFilters: true,
        getSearchLoading: false,
        searchLoading: false,
        showViewVisible: false,
        infoFormVisible: false,
        id:'',
        typeEdit: {},
        show3: false,
        enumData: [],
        editSubmitLoading: false,
        input: '',
        dialogFormVisible: false,
        val_time: '',
        serviceBillingRulesSelect: [],
        formLabelWidth: '120px'
      }
    },
    components: {
      Pagination,
    },
    created() {
      this.getdata()
      this.getlistForSelectTree(null)
      let param ={}


    },
    methods: {
      submitSearchForm() {
        this.getdata()
      },
      selectEdit(index, row, val) {

        this.info(row, val)
        this.state = this.ifuserType(row)
        console.log(this.state)
        this.tit = val

        this.ifuserTypes(row.networkType)
        this.ifuserTypea(row.agreementType)
        this.addOrEditForm.meterNums = row.meterNums
        this.addOrEditForm.meterCodeNums = row.meterCodeNums;
        this.addOrEditForm.networkTypeMsg = row.networkType.message
        this.addOrEditForm.meterAddrs = row.meterAddrs
        this.infoFormVisible = true
      },
      info(row, val) {
        this.addOrEditForm.id = row.id
        this.id =row.id
        this.addOrEditForm.meterTerminalName = row.meterTerminalName
        this.addOrEditForm.meterTerminalCode = row.meterTerminalCode

        this.addOrEditForm.state = row.state.toString()
        console.log(this.addOrEditForm.state)

        this.addOrEditForm.agreementType = row.agreementType

        this.addOrEditForm.networkType = row.networkType.code.toString()

        this.addOrEditForm.operatorId = row.operatorId
        this.addOrEditForm.nowVersion = row.nowVersion
        this.addOrEditForm.sim = row.sim
        this.addOrEditForm.stationId = row.stationId
        this.addOrEditForm.stationCode = row.stationCode
        this.addOrEditForm.meterCode = row.meterCode
        this.addOrEditForm.nowVersion = row.nowVersion
        this.addOrEditForm.timeSharingAccountingId = row.timeSharingAccountingId
        if (row.meterCodeNums != null && row.meterCodeNums != '') {
          this.addOrEditForm.meterCode = row.meterCodeNums.split(',')
        }

        this.addOrEditForm.signals = row.signals
        this.addOrEditForm.imei = row.imei
        this.addOrEditForm.loginPort = row.loginPort
        this.addOrEditForm.loginIp = row.loginIp
        console.log(this.addOrEditForm.state)
      },
      infoDialogClose() {
        this.infoFormVisible = false

        this.celerForm(this.addOrEditForm)
      },
      infoClose() {

        this.infoDialogClose()
      },

      deleteUser(index, row) {
        this.$confirm(this.$t('alaramMonitor.message4'), this.$t('alaramMonitor.message5'), {
            confirmButtonText: this.$t('deviceControl.confirm'),
            cancelButtonText: this.$t('alaramMonitor.cancel'),
            type: 'warning'
          })
          .then(() => {
            console.log(row.id)
            terminalApi.deleteTerminal(row.id)
              .then(res => {
                if (res.code === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$t('shu-ju-yi-shan-chu')
                  })


                  this.getdata()

                  this.handleDialogClose();
                } else {
                  this.$message({
                    type: 'info',
                    message: res.data.msg
                  })

                  this.handleDialogClose();
                }
              })
          })
      },
      handleEdit(index, row, val) {
        this.tit = val
        this.meterCodeVisible =true
        this.editFormVisible = true
        this.info(row)
        let par = []
        console.log(row)
        this.addOrEditForm.id= row.id
        this.zeroHourStatus =row.state.toString()

        if (this.addOrEditForm.operatorId != null) {
          let operatorId = this.addOrEditForm.operatorId
          par.push(operatorId);
          let param = {
            operatorIds: par
          }
          this.getServiceBillingRulesSelect(param)
        }
        // this.evlats('val')

        // this.evlat('val')
        this.getMeterCodes()
        this.getstationData(par)
      },

      resetSearchForm() {
        this.celerForm1(this.searchForm)

      },
      changeState() {},
      celerForm(from) {
        for (let item in from) {
          if (from[item]) {
            from[item] = ''
          }
        }
        from = Object.assign({}, this.changeEditForm)
        this.addOrEditForm= Object.assign({}, this.changeEditForm)
        console.log(from)

      },
      celerForm1(from) {
        for (let item in from) {
          if (from[item]) {
            from[item] = ''
          }
        }
        from.networkType=''
        from.state=null
        console.log(from)

      },
      selectChange() {},
      change(val) {
        this.$forceUpdate()
      },
      close() {
        console.log("a")
        this.$confirm(this.$t('que-ding-yao-qu-xiao-ma'), this.$t('alaramMonitor.message5'), {
            confirmButtonText: this.$t('deviceControl.confirm'),
            cancelButtonText: this.$t('alaramMonitor.cancel'),
            type: 'warning'
          })
          .then(() => {
            this.handleDialogClose()
          })
      },
      handleDialogClose() {
        this.editFormVisible = false
        this.celerForm(this.addOrEditForm)

        this.$refs.form.resetFields();
        this.addOrEditForm.agreementType = 0
      },
      evlat(val) {
        this.$forceUpdate()
        console.log(this.searchForm.operatorId)
        let par = []

        if (this.addOrEditForm.operatorId != null) {
          par.push(this.addOrEditForm.operatorId);
          this.getstationData(par)
          this.addOrEditForm.stationId = null

        }
      },
      filterValue(currentVal){

          if(currentVal.length > 0) {
                  this.options = this.optionsCopy.filter(item => {
                    if(currentVal === item.label.substring(0, currentVal.length)) {
                      return true
                    }
                  })
                  this.currentVal = currentVal
                } else {
                  this.options = this.optionsCopy
                  this.currentVal = ''
                }



      },
      // 根据手机号搜索客户
      async searchCustomerByPhone(query) {
        if(query.length > 4 ){
          this.searchLoading = true
          try {
            const {data} = await common.getCustomers(query)
            this.customers = data ? data : []
          } finally {
            this.searchLoading = false
          }
        }
      },

      changeOpertorId(val){
        this.$forceUpdate()

        console.log(this.searchForm.operatorId)
        let par = []
        let param ={}
        console.log(val)
        if (this.searchForm.operatorId != null && this.searchForm.operatorId !='') {
          par.push(this.searchForm.operatorId);
          this.getstationData(par)

          let param = {
            operatorIds: par
          }
        
          }
          if (this.addOrEditForm.operatorId != null && this.addOrEditForm.operatorId !='') {
            par.push(this.addOrEditForm.operatorId);
            this.getstationData(par)

            let param = {
              operatorIds: par
            }
           this.getServiceBillingRulesSelect(param)

        }

        this.addOrEditForm.stationId = null
        this.meterAcquisitios=[]
         this.addOrEditForm.id = null
        this.searchForm.stationId = null
        this.meterAcquisitios=[]
         this.searchForm.id = null
      },

      getServiceBillingRulesSelect(params) {
        stationApi.getRateSelectByOperatorId(params).then((res) => {
          console.info(JSON.stringify(res))
 
          this.serviceBillingRulesSelect = res
        })
      },
      evlats(val) {
        this.addOrEditForm.meterCode = ''
        this.addOrEditForm.meterAddr = ''

        this.getMeterCodes()
        // this.getMeterAddrs()
      },

      getMeterCodes() {
        if (this.addOrEditForm.stationId != null && this.addOrEditForm.stationId !="") {
          terminalApi.getMeterCodeList(this.addOrEditForm.stationId).then((res) => {
            console.log(res.data)
            this.meterCodes = res.data
          })
        }
      },
      // 编辑、添加提交方法
      submitForm(editData) {
        var meterCode = ''
        if (this.addOrEditForm.meterCode && this.addOrEditForm.meterCode != '') {
          meterCode = this.addOrEditForm.meterCode.join(',')
        }

        this.addOrEditForm.state =this.zeroHourStatus
        this.addOrEditForm.meterCodeNums = meterCode
        // if (this.addOrEditForm.state != null && this.addOrEditForm.state === "在线") {
        //   this.addOrEditForm.state = 0
        // }
        // if (this.addOrEditForm.state != null && this.addOrEditForm.state === "离线") {
        //   this.addOrEditForm.state = 1
        // }
        // if (this.addOrEditForm.state != null && this.addOrEditForm.state === "故障") {
        //   this.addOrEditForm.state = 2
        // }
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$confirm(this.$t('que-ding-yao-ti-jiao-ma'), this.$t('alaramMonitor.message5'), {
                confirmButtonText: this.$t('deviceControl.confirm'),
                cancelButtonText: this.$t('alaramMonitor.cancel'),
                type: 'warning'
              })
              .then(() => {
                terminalApi.inOrUpdate(this.addOrEditForm)
                  .then(res => {
                    if (res.code === 0) {
                      this.$message({
                        type: 'success',
                        message: this.$t('shu-ju-yi-ti-jiao')
                      })
                      this.getdata()

                      this.handleDialogClose();
                    } else {
                      this.$message({
                        type: 'info',
                        message: res.data.msg
                      })

                      this.handleDialogClose();
                    }
                  })
                  .catch(err => {
                    this.loading = false
                    console.log(this.addOrEditForm)
                    this.handleDialogClose();

                    this.getdata()
                    this.$message.error(this.$t('shu-ju-ti-jiao-shi-bai'))
                  })
              })
            // 向后台发送请求
          } else {
            this.$message(this.$t('qing-tian-xie-xiang-guan-nei-rong'));

            //就像用户提示发生错误的消息
          }
        })
      },
      getlistForSelectTree(val) {
        let param = {};
        let par = []
        configApi.getlistForSelectTree(param).then((res) => {
          if (res.code === 0) {
            this.listForSelectTree = res.data
            if (val == null) {
              for (var i = 0; i < res.data.length; i++) {
                par.push(res.data[i].value);
              }
            } else {
              par.push(val);
            }
            this.getstationData(par)
          }
        })
      },
      //获取所有的站点
      getstationData(param) {
        configApi.alarmStationAll(param).then((res) => {
          if (res.code === 0) {
            this.stations = res.data
          } else {
            this.$message.error(res.message)
          }

        })
      },
      changeStationId(){
        this.$forceUpdate()

        let par =this.searchForm.stationId
        console.log(this.searchForm.operatorId)

        if (this.addOrEditForm.stationId != null && this.addOrEditForm.stationId !="") {
          par=this.addOrEditForm.stationId
          this.getMeterCodes(par)


        }
                 this.searchForm.id = null

      },
      // 根据手机号搜索客户
       searchCustomerByPhone(query) {
        console.log(query)
        if(query.length > 4 ){
          this.searchLoading = true
        pileDateQueManagerApi.getMeterAcquisitionTerminalByStationId(query).then((res) => {
          if (res.code === 0) {
            this.meterAcquisitios = res.data
          } else {
            this.$message.error(res.message)
          }

        })
            this.searchLoading = false

        }
      },
      selectAlls(){
        console.log("aaa")
        if(this.searchForm.meterTerminalCode != null && this.searchForm.meterTerminalCode.length>=5) {
        pileDateQueManagerApi.getMeterAcquisitionTerminalByStationId().then((res) => {
          if (res.code === 0) {
            this.meterAcquisitios = res.data
          } else {
            this.$message.error(res.message)
          }

        })
        }
      },
      evlat(val){
        let par =[]
        par.push(this.searchForm.operatorId)
        this.getstationData(par)
      },
      handleSizeChange(val) {
        this.pageparam.pageSize = val
        this.getdata();
      },
      handleCurrentChange(val) {
        this.pageparam.currentPage = val
        this.getdata();
      },
      handleClick() {},
      // 获取数据方法
      getdata() {

        this.searchLoading = true
        this.getSearchLoading = true
        // let param = Object.assign({}, this.stationSearchForm)
        // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');

        this.pageparam.t = this.searchForm
        let param = Object.assign({}, this.pageparam)
        console.log(param)
        terminalApi.queryAll(param).then((res) => {
          if (res.code === 0) {

            this.tableData = res.data.list
            this.pageparam.total = res.data.total
            // this.$message({
            //   message: res.message,
            //   type: 'success'
            // })
          } else {
            this.$message.error(res.message)
          }
          this.searchLoading = false
          this.getSearchLoading = false
        })
      },
      add(val) {
        this.tit = val
        this.addOrEditForm.networkType = ''
        this.meterCodeVisible=false
        this.addOrEditForm.state = null
        this.addOrEditForm.agreementType = 0
        this.editFormVisible = true
      },
      ifuserTypes(val) {

        if (val == 0) {
          console.log(val)
          this.addOrEditForm.networkType = this.$t('you-xian-wang')

        } else if (val == 1) {
          this.addOrEditForm.networkType = this.$t('wu-xian-wang')

        }
      },
      ifuserTypea(val) {
        this.addOrEditForm.agreementType = this.$t('dian-wang-kuai-chong-0')
      },
      ifuserType(val) {

        if (val.state == 0) {
          this.addOrEditForm.state = this.$t('chargingMonitor.offline')
          return this.$t('chargingMonitor.offline')
        } else if (val.state == 1) {
          this.addOrEditForm.state = this.$t('zai-xian')
          return this.$t('zai-xian')
        } else if (val.state == 2) {
          this.addOrEditForm.state = this.$t('chargingMonitor.chargeFault')
          return this.$t('chargingMonitor.chargeFault')
        }

      }
    },
  }
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/acquisitionManager.vue